import React from "react";

// Horizontal wide logo (login/marketing)
export function LogoWide({ className = "" }) {
  return (
    <img
      src="/brand/logo-wide.webp"
      alt="ZTAN Technical Analyst"
      className={className}
      draggable={false}
    />
  );
}

// Compact square logo + Orbitron wordmark (header)
export default function Logo({ size = 40 }) {
  return (
    <div className="flex items-center gap-3">
      <img
        src="/brand/logo-square.webp"
        alt="ZTAN Live Group"
        style={{ height: size, width: size }}
        className="rounded-lg object-cover shadow-md"
        draggable={false}
      />
      <div className="leading-none">
        <div
          className="text-accent-yellow font-extrabold tracking-[0.14em] text-base sm:text-lg"
          style={{ fontFamily: "'Orbitron', 'Inter', sans-serif" }}
        >
          ZTAN LIVE GROUP
        </div>
        <div
          className="text-[10px] text-text-secondary mt-1 tracking-wide"
          style={{ fontFamily: "'Rajdhani', 'Inter', sans-serif", letterSpacing: "0.06em" }}
        >
          BIST Teknik Tarama
        </div>
      </div>
    </div>
  );
}
